import { searchCategory, searchLocation } from "apis";
import {
  FilterBar,
  FilterMultiSelect,
  FilterSingleSelect,
} from "components/commons";
import { useApi, useMount } from "hooks";
import { allCategoryRequest, allLocationRequest, location, categoryResponse } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject, mapObjectsToSelect } from "services";
import lang from "translations";

const ProductFilter = ({ filterState, requestState, modifyFilter, clearFilter, applyFilter }) => {
  const {
    request: searchCategoryRequest,
    loading: loadingCategories,
    mappedData: categories,
  } = useApi({
    api: searchCategory,
    isArray: true,
    mapper: categoryResponse,
    handleOwnError: true,
  });

  const {
    request: searchLocationRequest,
    loading: loadingLocations,
    mappedData: locations,
  } = useApi({
    api: searchLocation,
    isArray: true,
    mapper: location,
    handleOwnError: true,
  });
  useMount(() => {
    fetchCategoryRequest(requestState);
    fetchLocationRequest(requestState);
  });

  const fetchCategoryRequest = useCallback(
    (requestState) => {
      searchCategoryRequest(mapObject({ ...requestState }, allCategoryRequest));
    },
    [searchCategoryRequest]
  );

  const fetchLocationRequest = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [searchLocationRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await applyFilter(searchKey);
    },
    [applyFilter]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  const categoryOptions = useMemo(() => {
    return mapObjectsToSelect(categories, { textKey: "name" });
  }, [categories]);

  const locationOptions = useMemo(() => {
    let sorted = locations
      .map((item) => {
        item.name = item.name.trim();
        return item;
      })
      .sort((a, b) => (a.name > b.name ? 1 : -1));

    return mapObjectsToSelect(sorted, { textKey: "name" });
  }, [locations]);

  const posOptions = useMemo(() => {
    return [
      { text: lang.allProducts, value: null },
      { text: lang.sellingOnPos, value: true },
      { text: lang.notSellingOnPos, value: false },
    ];
  }, []);

  // const productStockLevelOptions = useMemo(() => {
  //   const productStockLevels = [
  //     ProductStockLevel.InStock,
  //     ProductStockLevel.CheckStock,
  //     ProductStockLevel.ReorderStock,
  //   ];
  //   return productStockLevels.map((type) => {
  //     return { text: prettifyProductStockLevel(type), value: type };
  //   });
  // }, []);

  return (
    <FilterBar
      placeholder={lang.searchProductByKeyOrSku}
      className="mb-lg"
      onClear={clearFilterCb}
      onApply={applyFilterCb}
      filterState={filterState}
    >
      <FilterMultiSelect
        id="categories"
        label={lang.productCategory}
        allLabel={lang.allCategories}
        emptyLabel={lang.noAvailableCategories}
        disableWhenEmpty={false}
        loading={loadingCategories}
        options={categoryOptions}
        value={filterState.categories}
        onChange={(value) => modifyFilter("categories", { value })}
      />
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocations}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
      {/* <Field className="col-span-3" filterLabel={lang.stockLevels}>
        <MultipleSelect
          name="productStockLevels"
          defaultAll={true}
          selectAllText={lang.allStockLevels}
          isAll={filterState.productStockLevels && filterState.productStockLevels.length === 0}
          options={productStockLevelOptions}
          value={filterState.productStockLevels}
          onChange={(name, obj) => {
            modifyFilter(name, { value: obj.value });
          }}
          placeholder={lang.selectStockLevel}
        />
      </Field> */}
      <FilterSingleSelect
        id="posStatus"
        label={lang.availabilityOnPos}
        summaryFallback={lang.allProducts}
        options={posOptions}
        value={filterState.posStatus}
        onChange={(value) => modifyFilter("posStatus", { value })}
      />
    </FilterBar>
  );
};

export default ProductFilter;
